import { SsoLogo, getSsoButtonLabel } from "@/components/settings/sso/SsoLogo";

export function SsoButton({ id, name, type }: { id: string; name: string; type: string }) {
  if (id === "facebook" || id === "twitter") {
    return <SsoLogo id={id} name={name} type={type} />;
  }

  return (
    <div className="inline-flex w-full justify-center rounded-md border border-zinc-300 bg-white px-4 py-2 text-sm font-medium text-zinc-500 shadow-sm hover:bg-zinc-50">
      <div className="flex flex-row items-center justify-around space-x-2">
        <SsoLogo id={id} name={name} type={type} />
        <div>{getSsoButtonLabel({ id, name, type })}</div>
      </div>
    </div>
  );
}
